module.exports = __webpack_public_path__ + "static/media/media3.691a6d40.jpg";